// src/lib/auth.js
// Centraliza la configuración de persistence de Firebase Auth
// Ejecuta UNA SOLA VEZ y devuelve promesa cuando esté listo

import {
  setPersistence,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  inMemoryPersistence,
} from "firebase/auth";

// Cache interno para ejecutar una sola vez
let persistencePromise = null;

/**
 * Inicializa persistence de Auth con fallback en cascada.
 * - Intenta: indexedDBLocalPersistence (estándar)
 * - Fallback: browserLocalPersistence (localStorage)
 * - Fallback final: inMemoryPersistence (más seguro para webview)
 * 
 * Se ejecuta UNA SOLA VEZ y cachea la promesa.
 * @param {Auth} auth - instancia de Firebase Auth
 * @returns {Promise<void>}
 */
export async function initializeAuthPersistence(auth) {
  // Si ya se está ejecutando o ya se ejecutó, devolver la promesa cacheada
  if (persistencePromise) {
    return persistencePromise;
  }

  // Crear promesa y cachearla ANTES de ejecutar cualquier async
  persistencePromise = (async () => {
    try {
      // Intento 1: indexedDBLocalPersistence (mejor para multi-tab)
      try {
        await setPersistence(auth, indexedDBLocalPersistence);
        console.log("[AUTH_PERSISTENCE] indexedDB persistence set ✓");
        return;
      } catch (indexedDbError) {
        console.warn(
          "[AUTH_PERSISTENCE] indexedDB not available, falling back to localStorage:",
          indexedDbError.code
        );
      }

      // Intento 2: browserLocalPersistence (localStorage)
      try {
        await setPersistence(auth, browserLocalPersistence);
        console.log("[AUTH_PERSISTENCE] localStorage persistence set ✓");
        return;
      } catch (localStorageError) {
        console.warn(
          "[AUTH_PERSISTENCE] localStorage not available, falling back to memory:",
          localStorageError.code
        );
      }

      // Fallback final: inMemoryPersistence (más seguro para webview/restricted envs)
      try {
        await setPersistence(auth, inMemoryPersistence);
        console.log("[AUTH_PERSISTENCE] in-memory persistence set ✓");
        return;
      } catch (memoryError) {
        console.warn(
          "[AUTH_PERSISTENCE] all persistence methods failed:",
          memoryError.code
        );
        // No lanzar error, permitir que siga (auth funcionará sin persistence)
        return;
      }
    } catch (unexpectedError) {
      console.error(
        "[AUTH_PERSISTENCE] unexpected error:",
        unexpectedError.message
      );
      // No lanzar, permitir que la app continúe
    }
  })();

  return persistencePromise;
}
